<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="form">
  <!--  bindLabel="formattedName"-->
  <ng-select
    [multiple]="true"
    [items]="data"
    bindLabel="number"
    bindValue="id"
    [loading]="loader"
    [formControlName]="'invoices_fake'"
    (add)="add($event.id)"
    (remove)="remove($event.value.id)"
    (clear)="clear()"
    [readonly]="disabled"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <div class="invoice-select-option-wrapper">
        <div class="invoice-option">
          {{ 'INVOICES_SELECT.NUMBER' | translate }}:
          <strong>{{ item.number || '-' }}</strong>
          /
          {{ 'INVOICES_SELECT.DATE' | translate }}:
          <strong>{{ item.date | amDateFormat : env.momentDateFormat || '-' }}</strong>
          /
          {{ 'INVOICES_SELECT.PERCENT' | translate }}:
          <strong> {{ item.deposit_percent || '-' }}</strong>

          /
          {{ 'INVOICES_SELECT.TOTAL_AMOUNT' | translate }}:
          <strong> {{ item.total_amount || '-' }} {{ item.currency?.symbol }}</strong>
        </div>
      </div>
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'NO_DATA_FOUND' | translate }} "{{ searchTerm }}"</div>
      </div>
    </ng-template>
  </ng-select>
</div>
